export const normalizeCatalogProduct = (data, id) => {
  const categories = Array.isArray(data.categories)
    ? data.categories.filter(Boolean)
    : (data.category ? [data.category] : []);
  const category = data.category || categories[0] || '';

  return {
    ...data,
    id,
    model: data.model || '',
    price: Number(data.price) || 0,
    stock: Number(data.stock) || 0,
    category,
    categories,
    description: data.description || '',
    images: Array.isArray(data.images) ? data.images : [],
    hidden: data.hidden ?? false,
    discountExcluded: data.discountExcluded ?? false,
    excludeFromStock: data.excludeFromStock ?? false,
    eventId: data.eventId || '',
    eventName: data.eventName || '',
    eventDate: data.eventDate || ''
  };
};

export const getCatalogCategories = (products) => {
  const fromCategory = products.map(product => product.category).filter(Boolean);
  const fromCategories = products.flatMap(product => product.categories || []);

  return [...new Set([...fromCategory, ...fromCategories])]
    .sort((a, b) => a.localeCompare(b));
};

export const matchesCatalogCategory = (product, selectedCategory) => {
  if (selectedCategory === 'all') return true;

  return product.category === selectedCategory
    || (Array.isArray(product.categories) && product.categories.includes(selectedCategory));
};

export const shouldShowCatalogProduct = (product, canEditCatalog) => {
  return canEditCatalog || product.hidden !== true;
};
